import React from "react";

const PoliticaPrivacidade = () => {
  return (
    <div
      style={{
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "40px",
        fontFamily: "'Poppins', sans-serif",
        lineHeight: "1.6",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#111",
          padding: "30px",
          borderRadius: "8px",
          border: "1px solid #444",
        }}
      >
        <h1 style={{ borderBottom: "2px solid #fff", paddingBottom: "10px" }}>
          Política de Privacidade
        </h1>

        <p>
          A sua privacidade é importante para nós. Esta Política de Privacidade
          descreve como coletamos, usamos e protegemos as informações
          fornecidas por você ao acessar nosso site e utilizar nossos serviços.
        </p>

        <h2>1. Coleta de Informações</h2>
        <p>
          Podemos coletar informações pessoais como nome, e-mail, telefone e
          dados de pagamento quando você interage com nosso site ou realiza uma
          compra. Também podemos coletar informações não pessoais, como
          endereço IP, tipo de navegador e páginas visitadas.
        </p>

        <h2>2. Uso das Informações</h2>
        <p>
          As informações coletadas são utilizadas para:
          <ul>
            <li>Processar suas compras e pagamentos</li>
            <li>Enviar comunicações importantes</li>
            <li>Melhorar nossos serviços e atendimento</li>
            <li>Personalizar sua experiência no site</li>
          </ul>
        </p>

        <h2>3. Compartilhamento de Informações</h2>
        <p>
          Não vendemos ou alugamos suas informações pessoais. Podemos
          compartilhá-las apenas com parceiros de confiança, prestadores de
          serviços e quando exigido por lei.
        </p>

        <h2>4. Segurança</h2>
        <p>
          Adotamos medidas de segurança para proteger suas informações, mas
          nenhum método de transmissão ou armazenamento eletrônico é 100%
          seguro.
        </p>

        <h2>5. Alterações nesta Política</h2>
        <p>
          Podemos atualizar esta política periodicamente. Qualquer alteração
          será publicada nesta página.
        </p>

        <p style={{ marginTop: "20px", fontSize: "14px", color: "#ccc" }}>
          Última atualização: 14 de Agosto de 2025
        </p>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;
